<div id="footer_container" class="opacity-0" [ngClass]="{'fixed-bottom':hasGlobalError===true}">
	<footer class="d-flex">
		<div class="logo copyright" title="Intranet homepage">
			<a routerLink="/" alt="Home Page">
				<img src="https://designassets.fosterandpartners.com/assets/images/svg/FP_Logo_Desktop.svg" title="Foster + Partner" alt="Foster + Partner"
					class="w-100" />
			</a>
		</div>
	</footer>
</div>